import PropTypes from 'prop-types';

import { Button, ModalV2 as Modal } from '@utilities';

const ConfirmRemoveTopicModal = ({
  confirmText = 'Remove',
  isActive,
  isConfirmDisabled,
  message = "Are you sure you would like to remove this topic card? You'll lose its results.",
  onCancel,
  onConfirm,
  title = 'Remove',
}) => (
  <Modal
    buttons={[
      <Button key="cancel-remove-topic" onClick={onCancel} text="Cancel" variant="secondary" />,
      <Button
        isDisabled={isConfirmDisabled}
        key="confirm-remove-topic"
        onClick={onConfirm}
        text={confirmText}
        variant="error"
      />,
    ]}
    isActive={isActive}
    onClose={onCancel}
    size="small"
    title={title}
  >
    <p>{message}</p>
  </Modal>
);

ConfirmRemoveTopicModal.propTypes = {
  confirmText: PropTypes.string,
  isActive: PropTypes.bool,
  isConfirmDisabled: PropTypes.bool,
  message: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default ConfirmRemoveTopicModal;
